<a class="header-logo" [href]="urlLink || '/'" *ngIf="!isCheckout; else noCheckout">
  <img src="{{ logoUrl }}" [ngClass]="{'has-white-label': hasWhiteLabel}"/>
</a>

<ng-template #noCheckout>
  <a class="header-logo">
    <img src="{{ logoUrl }}" [ngClass]="{ 'has-white-label': hasWhiteLabel }" />
  </a>
</ng-template>